import { render, staticRenderFns } from "./storeItem.vue?vue&type=template&id=12ed942e"
import script from "./storeItem.vue?vue&type=script&lang=js"
export * from "./storeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports